import { api, getAuthToken } from "@/boot/axios"
import type { MatchingCompany, DetailMatchingCompany } from "@/interfaces"

export function  useMatching() {

  const getMatchingList = async () => {
    try{
      const response = await api.get<MatchingCompany[]>('/matching/companies', {
        headers:{
          'Authorization': getAuthToken()
        }
      })
      return response.data
    } catch (er: any) {
      console.error(er)
      return[]
    }
  }

  const sendMatch = async (data: object) => {
    try{
      const response = await api.post(
        '/matching/match',
        data,
        {
          headers: {
            'Authorization': getAuthToken()
          }
        }
      )
      return response.data
    } catch (er) {
      console.error(er)
    }
  }

  const getCompanyDetail = async (companyId: number) => {
    try{
      const response = await api.get<DetailMatchingCompany>(`/matching/companies/${companyId}`, {
        headers: {
          'Authorization': getAuthToken()
        }
      })
      return response.data
    } catch (er) {
      console.error(er)
      return undefined
    }
  }

  return {
    getMatchingList,
    sendMatch,
    getCompanyDetail
  }
}